import {
    CLEAR_ALL,
    CLEAR_CRUD_USER,
    CLEAR_CURRENT_USER,
    DELETE_USER_SUCCESS,
    GET_CRUD_USER_REQUEST,
    GET_CRUD_USER_SUCCESS,
    GET_CRUD_USER_ERROR,
    GET_IMPL_SUMMARY_REQUEST,
    GET_IMPL_SUMMARY_SUCCESS,
    GET_IMPL_SUMMARY_ERROR,
    GET_PASSWORD_POLICIES_SUCCESS,
    GET_PASSWORD_POLICIES_ERROR,
    GET_SSO_PROVIER_SUCCESS,
    GET_SSO_PROVIER_ERROR,
    GET_USERS_REQUEST,
    GET_USERS_SUCCESS,
    GET_USERS_ERROR,
    GET_USERS_HIERACHY_REQUEST,
    GET_USERS_HIERACHY_SUCCESS,
    GET_USERS_HIERACHY_ERROR,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_ERROR,
    GET_USER_PERMISSIONS_SUCCESS,
    GET_USER_PERMISSIONS_ERROR,
    GET_USER_SCHEMA_SUCCESS,
    GET_USER_SCHEMA_ERROR,
    GET_USER_COUNTRY_CODES_SUCCESS,
    GET_USER_COUNTRY_CODES_ERROR,
} from 'constants/ActionTypes';
import { mapperUserToUserList } from 'utils/users';
import { sortByProp } from 'utils/array';

const initialState = {
    summary: null,
    summaryLoading: false,
    list: [],
    listLoading: false,
    listError: false,
    hasNextPage: false,
    hierachy: null,
    hierachyLoading: false,
    hierachyError: false,
    crudUser: null,
    crudUserLoading: false,
    crudUserError: false,
    currentUser: null,
    currentUserLoading: false,
    currentUserError: false,
    currentUserPermissions: null,
    passwordPolicies: null,
    schema: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_IMPL_SUMMARY_REQUEST:
            return {
                ...state,
                summaryLoading: true,
            };

        case GET_IMPL_SUMMARY_SUCCESS:
            return {
                ...state,
                summary: action.payload,
                summaryLoading: false,
            };

        case GET_IMPL_SUMMARY_ERROR:
            return {
                ...state,
                summary: null,
                summaryLoading: false,
            };

        case GET_USERS_REQUEST:
            return {
                ...state,
                listLoading: true,
                listError: false,
            };

        case GET_USERS_SUCCESS: {
            const { page, list } = action.payload;
            if (page === 0) {
                state.list = list;
            } else {
                state.list.push(...list);
            }
            return {
                ...state,
                listLoading: false,
                listError: false,
                hasNextPage: list.length === 100,
            };
        }

        case GET_USERS_ERROR:
            return {
                ...state,
                list: [],
                listLoading: false,
                listError: true,
                hasNextPage: false,
            };

        case GET_USERS_HIERACHY_REQUEST:
            return {
                ...state,
                hierachyLoading: true,
                hierachyError: false,
            };

        case GET_USERS_HIERACHY_SUCCESS:
            return {
                ...state,
                hierachyLoading: false,
                hierachyError: false,
                hierachy: action.payload,
            };

        case GET_USERS_HIERACHY_ERROR:
            return {
                ...state,
                hierachyLoading: false,
                hierachyError: true,
                hierachy: null,
            };

        case GET_USER_REQUEST:
            return {
                ...state,
                currentUserLoading: true,
                currentUserError: false,
            };

        case GET_USER_SUCCESS: {
            const userAux = action.payload;
            const userFound = state.list.find((user) => user.id === userAux.id);
            if (userFound) {
                mapperUserToUserList(userFound, userAux);
            }
            return {
                ...state,
                currentUserLoading: false,
                currentUser: action.payload,
                currentUserError: false,
                list: [...state.list],
            };
        }

        case GET_USER_ERROR:
            return {
                ...state,
                currentUserLoading: true,
                currentUser: null,
                currentUserError: true,
            };

        case GET_CRUD_USER_REQUEST:
            return {
                ...state,
                crudUserLoading: true,
                crudUserError: false,
            };

        case GET_CRUD_USER_SUCCESS:
            return {
                ...state,
                crudUserLoading: false,
                crudUser: action.payload,
                crudUserError: false,
            };

        case GET_CRUD_USER_ERROR:
            return {
                ...state,
                crudUserLoading: true,
                crudUser: null,
                crudUserError: true,
            };

        case GET_USER_PERMISSIONS_SUCCESS:
            return {
                ...state,
                currentUserPermissions: action.payload,
            };

        case GET_USER_PERMISSIONS_ERROR:
            return {
                ...state,
                currentUserPermissions: null,
            };

        case GET_PASSWORD_POLICIES_SUCCESS:
            return {
                ...state,
                passwordPolicies: action.payload,
            };

        case GET_PASSWORD_POLICIES_ERROR:
            return {
                ...state,
                passwordPolicies: null,
            };

        case GET_SSO_PROVIER_SUCCESS:
            return {
                ...state,
                authConfiguration: action.payload,
            };

        case GET_SSO_PROVIER_ERROR:
            return {
                ...state,
                authConfiguration: null,
            };

        case GET_USER_SCHEMA_SUCCESS:
            return {
                ...state,
                schema: action.payload,
            };

        case GET_USER_SCHEMA_ERROR:
            return {
                ...state,
                schema: {},
            };

        case GET_USER_COUNTRY_CODES_SUCCESS:
            return {
                ...state,
                countryCodes: action.payload,
                countryCodesNames: sortByProp(
                    action.payload.map((el) => ({
                        label: el.country,
                        value: el.id,
                    })),
                    'label',
                ),
                countryCodesPrefixes: action.payload.map((el) => ({
                    label: el.prefix,
                    value: el.id,
                })),
            };

        case GET_USER_COUNTRY_CODES_ERROR:
            return {
                ...state,
                countryCodes: [],
                countryCodesNames: [],
                countryCodesPrefixes: [],
            };

        case DELETE_USER_SUCCESS: {
            const id = action.payload;
            const index = state.list.findIndex((user) => user.id === id);
            if (index > -1) {
                state.list.splice(index, 1);
            }
            return {
                ...state,
            };
        }

        case CLEAR_CURRENT_USER:
            return {
                ...state,
                currentUser: null,
            };

        case CLEAR_CRUD_USER:
            return {
                ...state,
                crudUser: null,
            };

        case CLEAR_ALL:
            return initialState;

        default:
            return {
                ...state,
            };
    }
}
